import axios from 'axios';
import {server} from './server';

const axiosConfig = {
    withCredentials: true
}

const api = `${server}/api`

export const getLogin = async (username, password) => {
    return await axios.post(`${api}/login`,{username, password}, axiosConfig).then(response => response.data);
}

export const getSession = async () => {
    return await axios.get(`${api}/session`, axiosConfig)
        .then(response => response.data);
}

export const userLogout = async () => {
    return await axios.get(`${api}/logout`, axiosConfig)
        .then(response => response.data);
}

export const getInventory = async (showHidden) => {
    const url = (showHidden) ? `${api}/inventory/hidden` : `${api}/inventory`
    return await axios.get(url, axiosConfig)
        .then(r => r.data);
}

export const getInventoryById = async (inventoryId) => {
    return await axios.get(`${api}/inventory/${inventoryId}`, axiosConfig).then(r => r.data);
}

export const getInventoryByProduct = async (productId) => {
    return await axios.get(`${api}/inventory/product/${productId}`, axiosConfig).then(r => r.data);
}

export const getAllProducts = async () => {
    return await axios.get(`${api}/product`, axiosConfig)
        .then(r => r.data);
}

export const getProduct = async (productId) => {
    return await axios.get(`${api}/product/${productId}`, axiosConfig).then(r => r.data[0])
}

export const getProductCategory = async(category) => {
    return await axios.get(`${api}/product/category/${category}`, axiosConfig).then(r => r.data)
}

export const insertProduct = async (name, description, category, type, subtype, options) => {
    return await axios.post(`${api}/product`, {
        name, description, category, type, subtype,
        sku: options.sku,
        vendorId: options.vendorId,
        strain: options.strain,
        brand: options.brand,
        packagedType: options.packagedType,
        bulkSize: options.bulkSize,
    }, axiosConfig);
}

export const updateProduct = async (productId, options) => {
    return await axios.post(`${api}/product/update`, {
        id: productId,
        ...options
    }, axiosConfig);
}
export const getProductIngredients = async (productId) => {
    return await axios.get(`${api}/product/${productId}/ingredients`, axiosConfig).then(r => r.data);
}

export const insertProductIngredient = async (productId, ingredientId, ratio) => {
    return await axios.post(`${api}/product/${productId}/ingredient`, {
        productId, ingredientId, ratio
    }, axiosConfig).then(r => r.data);
}

export const deleteProductIngredient = async (productId, ingredientId) => {
    return await axios.post(`${api}/product/${productId}/ingredient/delete`, {
        productId, ingredientId
    }, axiosConfig).then(r => r.data);
}

export const insertInventory = async(itemId, quantity, category, options) => {
    return await axios.post(`${api}/inventory/insert`, {
        itemId, quantity, category,
        sku: options.sku,
        unit: options.unit,
        cost: options.cost,
        book: options.book,
        shipping: options.shipping,
        tariff: options.tariff,
        batchId: options.batchId,
        bulkCost: options.bulkCost,
    }, axiosConfig).then(r => r.data);
}

export const setInventory = async (name, description, quantity, category, type, subtype, options) => {
    return await axios.post(`${api}/inventory`, {
        name, description, quantity, category, type, subtype,
        skuPrefix: options.skuPrefix,
        sku: options.sku,
        vendorId: options.vendorId,
        strain: options.strain,
        cost: options.cost,
        book: options.book,
        shipping: options.shipping,
        tariff: options.tariff,
        brand: options.brand,
        packagedType: options.packagedType,
        bulkSize: options.bulkSize,
        bulkCost: options.bulkCost,
        unit: options.unit
    }, axiosConfig).then(r => r.data);
}

export const updateInventory = async (id, quantity, isSet, notes) => {
    return await axios.post(`${api}/inventory/${id}/quantity`, {
        id, quantity, isSet, notes
    }, axiosConfig);
}

export const updateInventoryHidden = async (id, hidden) => {
    return await axios.post(`${api}/inventory/${id}/hidden`, {
        id, hidden
    }, axiosConfig).then(r => r.data);
}

export const updateInventorySku = async (id, sku) => {
    return await axios.post(`${api}/inventory/${id}/sku`, {
        id, sku
    }, axiosConfig).then(r => r.data);
}

export const updateInventoryCost = async (id, cost) => {
    return await axios.post(`${api}/inventory/${id}/cost`, {
        id, ...cost
    }, axiosConfig).then(r => r.data);
}

export const updateInventoryBook = async (id, book) => {
    return await axios.post(`${api}/inventory/${id}/book`, {
        id, book
    }, axiosConfig).then(r => r.data);
}

export const updateInventoryDescription = async (id, description) => {
    return await axios.post(`${api}/inventory/${id}/description`, {id, description}, axiosConfig).then(r => r.data);
}

export const addInventoryToCart = async (itemId, quantity) => {
    return await axios.post(`${api}/inventory/cart`, {
        itemId,
        quantity
    }, axiosConfig);
}

export const getInventoryLog = async (inventoryId) => {
    return await axios.get(`${api}/inventory/log/${inventoryId}`, axiosConfig).then(r => r.data);
}

export const updateInventoryAlert = async (inventoryId, quantity, enable) => {
    return await axios.post(`${api}/inventory/alert`, {
        id: inventoryId, quantity, enable
    }, axiosConfig).then(r => r.data);
}

export const clearCart = async (immediate) => {
    const url = (immediate) ? `${api}/inventory/cart/delete` : `${api}/inventory/cart/timeout`
    return await axios.get(url, axiosConfig).then(r => r.data);
}

export const clearCartForUser = async () => {
    return await axios.get(`${api}/inventory/cart/delete/all`, axiosConfig).then(r => r.data);
}

export const getCart = async () => {
    return await axios.get(`${api}/inventory/cart`, axiosConfig).then(r => r.data);
}

export const getSystemCart = async () => {
    return await axios.get(`${api}/admin/cart`, axiosConfig).then(r => r.data);
}

export const clearCartItemForSession = async (sessionId, inventoryId) => {
    return await axios.post(`${api}/admin/clear/cart/item`, {sessionId, inventoryId}, axiosConfig).then(r => r.data);
}

export const getUsers = async () => {
    return await axios.get(`${api}/user`, axiosConfig)
        .then(r => r.data);
}

export const getUserRates = async () => {
    return await axios.get(`${api}/user/rate`, axiosConfig)
        .then(r => r.data);
}

export const setUserDepartment = async (id, department) => {
    return await axios.get(`${api}/user/${id}/department/${department}`, axiosConfig);
}

export const setNewUser = async (username, firstname, lastname, department, password) => {
    return await axios.post(`${api}/user`, {
        username, firstname, lastname, department, password
    }, axiosConfig)
}

export const setUserPassword = async (id, password) => {
    // admin updating a user's password
    return await axios.get(`${api}/user/${id}/password/${password}`, axiosConfig)
}

export const changeUserPassword = async (password, newPassword) => {
    // user updating their own password
    return await axios.post(`${api}/user/password`, {password, newPassword}, axiosConfig).then(r => r.data);
}

export const setUserRate = async (id, hourRate) => {
    return await axios.post(`${api}/user/rate`, {id, hourRate}, axiosConfig).then(r => r.data);
}

export const setUserActive = async (id, active) => {
    return await axios.post(`${api}/user/active`, {id, active}, axiosConfig).then(r => r.data);
}

export const setUserEmail = async (id, email) => {
    return await axios.post(`${api}/user/email`, {id, email}, axiosConfig).then(r=> r.data);
}

export const getUserDetails = async (id) => {
    return await axios.get(`${api}/user/${id}/details`, axiosConfig).then(r => r.data);
}

export const setUserPermission = async (userId, permType, value) => {
    const permission = {}
    permission[permType] = value;
    return await axios.post(`${api}/user/permission`, {userId, permission}, axiosConfig).then(r => r.data)
}

export const getAllBuyers = async () => {
    return await axios.get(`${api}/buyer`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getBuyer = async (buyerId) => {
    return await axios.get(`${api}/buyer/${buyerId}`, axiosConfig).then(r => r.data);
}

export const setNewBuyer = async (firstname, lastname, company, license) => {
    return await axios.post(`${api}/buyer`, {
        firstname, lastname, company, license}, axiosConfig).then(r => r.data);
}

export const getAddressesForBuyer = async (id) => {
    return await axios.get(`${api}/buyer/${id}/address`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getEmailAddressesForBuyer = async (id) => {
    return await axios.get(`${api}/buyer/${id}/email`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getPaymentsForBuyer = async (id) => {
    return await axios.get(`${api}/buyer/${id}/payments`, axiosConfig).then(r => r.data);
}

export const getPhoneNumbersForBuyer = async (id) => {
    return await axios.get(`${api}/buyer/${id}/phonenumber`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const setEmailAddressForBuyer = async (buyerId, email, description, primary) => {
    return await axios.post(`${api}/buyer/${buyerId}/email`, {
        id: buyerId, email, description, primary
    }, axiosConfig);
}

export const setPrimaryEmailAddressForBuyer = async (buyerId, emailId) => {
    return await axios.post(`${api}/buyer/${buyerId}/email/primary`, {
        buyerId, emailId
    }, axiosConfig);
}

export const setPhoneNumberForBuyer = async (buyerId, phoneNumber, description, primary=false) => {
    return await axios.post(`${api}/buyer/${buyerId}/phonenumber`, {
        id: buyerId, phoneNumber, description, primary
    }, axiosConfig);
}

export const setPrimaryPhoneNumberForBuyer = async (buyerId, phoneId) => {
    return await axios.post(`${api}/buyer/${buyerId}/phonenumber/primary`, {
        buyerId, phoneId
    }, axiosConfig);
}

export const setAddressForBuyer = async (buyerId, streetAddress, streetAddressLine2, city, state,
    country, postalCode, description, primary=false) => {

    return await axios.post(`${api}/buyer/${buyerId}/address`, {
        id: buyerId, streetAddress, streetAddressLine2, city, state, country, postalCode, description, primary
    }, axiosConfig)
}

export const setPrimaryAddressForBuyer = async (buyerId, addressId) => {
    return await axios.post(`${api}/buyer/${buyerId}/address/primary`, {
        buyerId, addressId
    }, axiosConfig)
}

export const createInvoice = async (buyerId) => {
    return await axios.post(`${api}/invoice`, {buyerId}, axiosConfig).then(r => r.data);
}

export const getAllInvoices = async () => {
    return await axios.get(`${api}/invoice/open`, axiosConfig).then(r => r.data);
}

export const getInvoice = async (invoiceId) => {
    return await axios.get(`${api}/invoice/${invoiceId}`, axiosConfig).then(r => r.data[0]);
}

export const getPaidInvoices = async () => {
    return await axios.get(`${api}/invoice/paid`, axiosConfig).then(r => r.data);
}

export const getCompleteInvoices = async () => {
    return await axios.get(`${api}/invoice/all`, axiosConfig).then(r => r.data);
}
export const getBuyerInvoices = async (buyerId) => {
    return await axios.get(`${api}/invoice/buyer/${buyerId}`, axiosConfig).then(r => r.data);
}

export const getInvoiceLines = async (invoiceId) => {
    return await axios.get(`${api}/invoice/${invoiceId}/lineitems`, axiosConfig).then(r => r.data);
}

export const insertInvoicePayment = async (invoiceId, amount, accountId, notes) => {
    return await axios.post(`${api}/invoice/payment`, {
        invoiceId, amount, accountId, notes
    }, axiosConfig).then(r => r.data);
}

export const updateInvoicePaymentAmount = async (paymentId, amount) => {
    return await axios.post(`${api}/invoice/payment/${paymentId}`, {
        paymentId, amount}, axiosConfig).then(r => r.data);
}

export const updateInvoicePaymentAccount = async (paymentId, accountId) => {
    return await axios.post(`${api}/invoice/payment/${paymentId}`, {
        paymentId, accountId}, axiosConfig).then(r => r.data);
}

export const getInvoicePayments = async (invoiceId) => {
    return await axios.get(`${api}/invoice/${invoiceId}/payment`, axiosConfig).then(r => r.data);
}

export const getBankAccounts = async () => {
    return await axios.get(`${api}/bank/account`, axiosConfig).then(r => r.data);
}

export const insertExpense = async (amount, accountId, department, category, notes, vendorId, date) => {
    return await axios.post(`${api}/bank/expense`, {
        amount, accountId, department, category, notes, vendorId, date
    }, axiosConfig).then(r => r.data);
}

export const insertPayment = async (amount, accountId, date, notes) => {
    return await axios.post(`${api}/bank/transaction/payment`, {
        amount, accountId, date, notes
    }, axiosConfig).then(r => r.data);
}

export const verifyInvoiceTransactions = async (invoiceId) => {
    return await axios.post(`${api}/bank/invoice/verify`, {
        invoiceId
    }, axiosConfig);
}

export const verifyPayment = async (id) => {
    return await axios.post(`${api}/bank/payment/verify`, {
        id, invalid: false
    }, axiosConfig);
}

export const invalidatePayment = async (id) => {
    return await axios.post(`${api}/bank/payment/verify`, {
        id, invalid: true
    }, axiosConfig);
}

export const updateTransactionAmount = async (transactionId, amount) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/amount`, {
        transactionId, amount
    }, axiosConfig).then(r => r.data);
}

export const updateTransactionDate = async (transactionId, date) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/date`, {
        transactionId, date
    }, axiosConfig).then(r => r.data);
}

export const updateTransactionNotes = async (transactionId, notes) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/notes`, {
        transactionId, notes
    }, axiosConfig).then(r => r.data);
}

export const updateTransactionDepartment = async (transactionId, department) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/department`, {
        transactionId, department
    }, axiosConfig).then(r => r.data);
}

export const updateTransactionCategory = async (transactionId, category) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/category`, {
        transactionId, category
    }, axiosConfig).then(r => r.data);
}

export const updateTransactionVendor = async (transactionId, vendorId) => {
    return await axios.post(`${api}/bank/transaction/${transactionId}/vendor`, {
        transactionId, vendorId
    }, axiosConfig).then(r => r.data);
}

export const getTransactionLog = async (transactionId) => {
    return await axios.get(`${api}/bank/transaction/${transactionId}/log`, axiosConfig).then(r => r.data);
}

export const insertInvoiceLineItems = async (invoiceId, lineItems) => {
    return await axios.post(`${api}/invoice/${invoiceId}/lineitems`, {
        invoiceId, lineItems
    }, axiosConfig);
}

export const deleteInvoiceLineItem = async (invoiceId, lineId) => {
    return await axios.post(`${api}/invoice/${invoiceId}/lineitem/${lineId}/delete`,
        {}, axiosConfig);
}

export const updateInvoiceLineItemPrice = async (id, linePrice) => {
    return await axios.post(`${api}/invoice/lineitem/update/price`, {
        id, linePrice
    }, axiosConfig);
}

export const updateInvoiceLineItemDiscount = async (id, lineDiscount) => {
    return await axios.post(`${api}/invoice/lineitem/update/discount`, {
        id, lineDiscount
    }, axiosConfig);
}

export const updateInvoiceLineItemPaid = async (id, totalPaid) => {
    return await axios.post(`${api}/invoice/lineitem/update/amountpaid`, {
        id, totalPaid
    }, axiosConfig);
}

export const updateInvoiceState = async (invoiceId, state) => {
    return await axios.post(`${api}/invoice/${invoiceId}/state`, {
        invoiceId, state
    }, axiosConfig);
}

export const getBankBalances = async () => {
    return await axios.get(`${api}/bank/balances`, axiosConfig).then(r => r.data);
}

export const getInvoicesForBank = async (accountId) => {
    return await axios.get(`${api}/bank/account/${accountId}/invoice`, axiosConfig)
        .then(r => r.data);
}

export const insertBankTransfer = async (source, dest, amount, date) => {
    return await axios.post(`${api}/bank/transfer`, {source, dest, amount, date}, axiosConfig)
        .then(r => r.data);
}

export const getAllRecordedPayments = async () => {
    return await axios.get(`${api}/invoice/payment/recorded`, axiosConfig).then(r => r.data);
}

export const getTransaction = async (transactionId) => {
    return await axios.get(`${api}/bank/transaction/${transactionId}`, axiosConfig).then(r => r.data[0]);
}

export const createPurchaseOrder = async (buyerId, dueDate, notes, productList) => {
    return await axios.post(`${api}/purchaseorder`, {buyerId, dueDate, notes, productList}, axiosConfig)
        .then(r => r.data);
}

export const getPurchaseOrders = async (state, exact=false) => {
    return await axios.get(`${api}/purchaseorder/state/${state}/exact/${exact}`, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLines = async (purchaseId) => {
    return await axios.get(`${api}/purchaseorder/${purchaseId}/lineitems`, axiosConfig).then(r => r.data);
}

export const getPurchaseOrder = async (purchaseId) => {
    return await axios.get(`${api}/purchaseorder/${purchaseId}`, axiosConfig).then(r => r.data[0]);
}

export const insertPurchaseOrderLineItem = async (purchaseId, lineItem) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/lineItem`, {purchaseId, lineItem},
        axiosConfig).then(r => r.data);
}

export const deletePurchaseOrderLineItem = async (purchaseId, lineId) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/lineItem/${lineId}/delete`, {purchaseId, lineId},
        axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLineItem = async (purchaseId, lineId) => {
    return await axios.get(`${api}/purchaseorder/${purchaseId}/lineItem/${lineId}`, axiosConfig).then(r => r.data[0]);
}

export const updatePurchaseOrderState = async (purchaseId, state) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/update/state`, {
        purchaseId, state}, axiosConfig).then(r => r.data);
}

export const updatePurchaseOrderNotes = async (purchaseId, notes) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/update/notes`, {
        purchaseId, notes}, axiosConfig).then(r => r.data);
}

export const getAllPurchaseOrderLines = async (state) => {
    return await axios.get(`${api}/purchaseorder/lineitems/state/${state}`, axiosConfig).then(r => r.data);
}

export const completePurchaseOrderLine = async (purchaseId, lineId, lineItems, productId, quantity, unit, sku, cost, hours, book, description) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/lineItem/${lineId}/complete`, {
        purchaseId, lineId, lineItems, productId, quantity, unit, sku, cost, hours, book, description}, axiosConfig);
}

export const undoPurchaseOrderLineItem = async (purchaseId, lineId) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/lineItem/${lineId}/undo`, {
        purchaseId, lineId}, axiosConfig).then(r => r.data);
}

export const updatePurchaseOrderLineState = async (lineId, state) => {
    return await axios.post(`${api}/purchaseorder/lineItem/:lineId/state`, {
        lineId, state
    }, axiosConfig);
}

export const updatePurchaseOrderLineQuantity = async (purchaseId, lineId, quantity) => {
    return await axios.post(`${api}/purchaseOrder/${purchaseId}/lineItem/${lineId}/quantity`,
        {lineId, quantity}, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLineCreation = async (lineId) => {
    return await axios.get(`${api}/purchaseorder/lineitem/${lineId}/creation`, axiosConfig).then(r => r.data);
}

export const insertPurchaseOrderTask = async (purchaseId, tasks) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/task`, {
        purchaseId, tasks
    }, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderTask = async (purchaseId) => {
    return await axios.get(`${api}/purchaseorder/${purchaseId}/task`, axiosConfig).then(r => r.data);
}

export const insertPurchaseOrderLabor = async (purchaseId, notes, hours) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/labor`, {purchaseId, notes, hours}, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderLabor = async (purchaseId) => {
    return await axios.get(`${api}/purchaseorder/${purchaseId}/labor`, axiosConfig).then(r => r.data);
}

export const updatePurchaseOrderLabor = async (purchaseId, id, notes, hours) => {
    return await axios.post(`${api}/purchaseorder/${purchaseId}/labor/${id}`, {purchaseId, id, notes, hours}, axiosConfig).then(r => r.data);
}

export const insertReturn = async (invoiceId, invoiceLineId, inventoryId, quantity, refundAmount, accountId, notes) => {
    return await axios.post(`${api}/return`, {
        invoiceId, invoiceLineId, inventoryId, quantity, refundAmount, accountId, notes
    }, axiosConfig)
}

export const getAllReturns = async () => {
    return await axios.get(`${api}/return`, axiosConfig).then(r => r.data);
}

export const getReturnsForInvoice = async (invoiceId) => {
    return await axios.get(`${api}/return/invoice/${invoiceId}`, axiosConfig).then(r => r.data);
}

export const getAllBatches = async () => {
    return await axios.get(`${api}/cultivation/batch/all`, axiosConfig).then(r => r.data);
}

export const getBatch = async (batchId) => {
    return await axios.get(`${api}/cultivation/batch/${batchId}`, axiosConfig).then(r => r.data[0]);
}

export const insertBatch = async (name, description) => {
    return await axios.post(`${api}/cultivation/batch`, {name, description}, axiosConfig);
}

export const hideBatch = async (batchId, hidden) => {
    return await axios.post(`${api}/cultivation/batch/${batchId}/delete`, {batchId, hidden}, axiosConfig).then(r=>r.data);
}

export const getAllVendors = async () => {
    return await axios.get(`${api}/vendor`, axiosConfig).then(r => r.data);
}

export const getVendor = async (vendorId) => {
    return await axios.get(`${api}/vendor/${vendorId}`, axiosConfig).then(r => r.data[0]);
}

export const insertVendor = async (company) => {
    return await axios.post(`${api}/vendor`, {company}, axiosConfig).then(r=> r.data);
}

export const setEmailAddressForVendor = async (vendorId, email, description) => {
    return await axios.post(`${api}/vendor/${vendorId}/email`, {
        id: vendorId, email, description
    }, axiosConfig);
}

export const setPhoneNumberForVendor = async (vendorId, phoneNumber, description) => {
    return await axios.post(`${api}/vendor/${vendorId}/phonenumber`, {
        id: vendorId, phoneNumber, description
    }, axiosConfig);
}

export const setAddressForVendor = async (vendorId, streetAddress, streetAddressLine2, city, state,
                                         country, postalCode, description) => {

    return await axios.post(`${api}/vendor/${vendorId}/address`, {
        id: vendorId, streetAddress, streetAddressLine2, city, state, country, postalCode, description
    }, axiosConfig)
}

export const setPrimaryEmailAddressForVendor = async (vendorId, emailId) => {
    return await axios.post(`${api}/vendor/${vendorId}/email/primary`, {
        vendorId, emailId,
    }, axiosConfig);
}

export const setPrimaryPhoneNumberForVendor = async (vendorId, phoneId) => {
    return await axios.post(`${api}/vendor/${vendorId}/phonenumber/primary`, {
        vendorId, phoneId
    }, axiosConfig);
}

export const setPrimaryAddressForVendor = async (vendorId, addressId) => {
    return await axios.post(`${api}/vendor/${vendorId}/address/primary`, {
        vendorId, addressId,
    }, axiosConfig)
}

export const getAddressesForVendor = async (id) => {
    return await axios.get(`${api}/vendor/${id}/address`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getEmailAddressesForVendor = async (id) => {
    return await axios.get(`${api}/vendor/${id}/email`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getPhoneNumbersForVendor = async (id) => {
    return await axios.get(`${api}/vendor/${id}/phonenumber`, axiosConfig)
        .then(function (response) {
            return response.data;
        });
}

export const getProfitReport = async (startDate, endDate) => {
    return await axios.post(`${api}/report/profit`, {startDate, endDate},
        axiosConfig).then(r => r.data);
}

export const getCogsReport = async (startDate, endDate, type, subtype) => {
    return await axios.post(`${api}/report/cogs`, {startDate, endDate, type, subtype},
        axiosConfig).then(r => r.data);
}

export const getBatchReport = async (batchId) => {
    return await axios.post(`${api}/report/batch`, {batchId}, axiosConfig).then(r => r.data);
}

export const getPurchaseOrderReport = async (startDate, endDate, buyerId) => {
    return await axios.post(`${api}/report/purchaseorder`, {startDate, endDate, buyerId}, axiosConfig).then(r => r.data);
}

export const getCashFlowReport = async (startDate, endDate) => {
    return await axios.post(`${api}/report/cashflow`, {startDate, endDate}, axiosConfig).then(r => r.data);
}

export const getOwnedTasks = async () => {
    return await axios.get(`${api}/task/own`, axiosConfig).then(r => r.data);
}

export const getAssignedTasks = async () => {
    return await axios.get(`${api}/task/assigned`, axiosConfig).then(r => r.data);
}

export const getTask = async (taskId) => {
    return await axios.get(`${api}/task/${taskId}`, axiosConfig).then(r => r.data[0]);
}

export const getAllTasks = async () => {
    return await axios.get(`${api}/task/all`, axiosConfig).then(r => r.data);
}

export const getTasksByDepartment = async (department) => {
    return await axios.get(`${api}/task/department/${department}`, axiosConfig).then(r => r.data);
}

export const getFollowedTasks = async () => {
    return await axios.get(`${api}/task/follow`, axiosConfig).then(r => r.data);
}

export const getTaskCount = async () => {
    return await axios.get(`${api}/task/count`, axiosConfig).then(r => r.data[0]);
}

export const insertTask = async (title, description, assignedTo, dueDate) => {
    return await axios.post(`${api}/task`, {title, description, assignedTo, dueDate}, axiosConfig)
        .then(r => r.data);

}

export const updateTaskAssignedTo = async (id, assignedTo) => {
    return await axios.post(`${api}/task/${id}/assignedTo`,{id, assignedTo}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskStatus = async (id, status) => {
    return await axios.post(`${api}/task/${id}/status`,{id, status}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskTitle = async (id, title) => {
    return await axios.post(`${api}/task/${id}/title`,{id, title}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskDescription = async (id, description) => {
    return await axios.post(`${api}/task/${id}/description`,{id, description}, axiosConfig)
        .then(r => r.data);
}

export const updateTaskDueDate = async (id, dueDate) => {
    return await axios.post(`${api}/task/${id}/dueDate`, {id, dueDate}, axiosConfig)
        .then(r => r.data);
}

export const getTaskNotes = async (taskId) => {
    return await axios.get(`${api}/task/${taskId}/notes`, axiosConfig).then(r => r.data);
}

export const insertTaskNote = async (taskId, notes) => {
    return await axios.post(`${api}/task/${taskId}/notes`, {taskId, notes}, axiosConfig).then(r => r.data);
}

export const updateTaskNote = async (taskId, noteId, notes) => {
    return await axios.post(`${api}/task/${taskId}/note/${noteId}`, {noteId, notes, taskId}, axiosConfig).then(r => r.data);
}

export const insertTaskFollower = async (taskId, followers) => {
    return await axios.post(`${api}/task/${taskId}/follower`, {taskId, followers}, axiosConfig).then(r => r.data);
}

export const getTaskFollowers = async (taskId) => {
    return await axios.get(`${api}/task/${taskId}/follower`, axiosConfig).then(r => r.data);
}

export const deleteTaskFollower = async (taskId, userId) => {
    return await axios.post(`${api}/task/${taskId}/follower/delete`, {taskId, userId}, axiosConfig)
        .then(r => r.data);
}

export const insertMomPlant = async (name, description, strain, metricTag) => {
    return await axios.post(`${api}/cultivation/mom`, {name, description, strain, metricTag}, axiosConfig)
        .then(r => r.data);
}

export const getMomPlants = async () => {
    return await axios.get(`${api}/cultivation/mom`, axiosConfig).then(r => r.data);
}

export const getDestroyedPlants = async () => {
    return await axios.get(`${api}/cultivation/plant/destroyed`, axiosConfig).then(r => r.data);
}

export const getMomPlant = async (momId) => {
    return await axios.get(`${api}/cultivation/mom/${momId}`, axiosConfig).then(r => r.data[0]);
}

export const getPlants = async (roomId) => {
    if (roomId === undefined) { roomId = "all"}
    return await axios.get(`${api}/cultivation/plant/room/${roomId}`, axiosConfig).then(r => r.data);
}

export const getPlantsByStage = async (roomId, stage) => {
    return await axios.get(`${api}/cultivation/plant/room/${roomId}/stage/${stage}`, axiosConfig).then(r => r.data);
}

export const getPlantsByGenetics = async (geneticId) => {
    return await axios.get(`${api}/cultivation/plant/genetic/${geneticId}`, axiosConfig).then(r => r.data);
}

export const getPlant = async (plantId) => {
    return await axios.get(`${api}/cultivation/plant/${plantId}`, axiosConfig).then(r => r.data[0]);
}

export const updateMomPlant = async (momId, options) => {
    return axios.post(`${api}/cultivation/mom/${momId}`, {
        momId,
        ...options
    }, axiosConfig).then(r => r.data);
}

export const getMomEvents = async (momId) => {
    return await axios.get(`${api}/cultivation/mom/${momId}/events`, axiosConfig).then(r => r.data);
}

export const cloneMom = async (momId, numClones, createdBy, notes) => {
    return await axios.post(`${api}/cultivation/clone/${momId}`, {
        momId, numClones, createdBy, notes
    }, axiosConfig).then(r => r.data);
}

export const destroyMom = async (momId, notes) => {
    return await axios.post(`${api}/cultivation/mom/${momId}/destroy`, {
        momId, notes
    }, axiosConfig).then(r => r.data);
}

export const destroyClone = async (plantId, count,  notes) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/destroy`, {
        plantId, count, notes
    }, axiosConfig).then(r => r.data);
}

export const insertPlantMetrics = async (metrics) => {
    return await axios.post(`${api}/cultivation/mom/metrics`, {
        metrics
    }, axiosConfig).then(r => r.data);
}

export const updatePlantMetric =  async (id, data, date) => {
    return await axios.post(`${api}/cultivation/plant/metric/${id}`, {
        id, data, date
    }, axiosConfig).then(r => r.data);
}

export const insertRoomMetrics = async (roomId, values, isDelete) => {
    return await axios.post(`${api}/cultivation/room/${roomId}/metric`, {
        roomId, values, isDelete
    }, axiosConfig).then(r => r.data);
}

export const getRoomMetrics = async (roomId, start, end) => {
    return await axios.post(`${api}/cultivation/room/${roomId}/getmetric`, {
        roomId, start, end
    }, axiosConfig).then(r => r.data);
}

export const insertRowMetrics = async (rowId, metric, values, isDelete) => {
    return await axios.post(`${api}/cultivation/row/${rowId}/metric`, {
        rowId, metric, values, isDelete
    }, axiosConfig).then(r => r.data);
}

export const getRowMetrics = async (rowIds, start, end) => {
    return await axios.post(`${api}/cultivation/row/getmetric`, {
        rowIds, start, end
    }, axiosConfig).then(r => r.data);
}

export const getLatestRowMetric = async (rowId, metric) => {
    return await axios.post(`${api}/cultivation/row/latestmetric`, {rowId, metric}, axiosConfig).then(r => r.data);
}

// transfer moves a plant to a different room
export const transferPlant = async (id, count, stage, roomId, notes) => {
    return await axios.post(`${api}/cultivation/plant/${id}/transfer`, {
        id, count, stage, roomId, notes
    }, axiosConfig).then(r => r.data);
}

// split a plant group in the same room
export const splitPlantGroup = async (id, count, notes) => {
    return await axios.post(`${api}/cultivation/plant/${id}/split`, {
        id, count, notes
    }, axiosConfig).then(r => r.data);
}

// update plant location sets the (table) row for the plant
export const updatePlantLocation = async(plantId, roomId, rowId) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/row`, {
        plantId, roomId, rowId
    }, axiosConfig).then(r => r.data);
}

export const getCultivationRooms = async () => {
    return await axios.get(`${api}/cultivation/rooms`, axiosConfig).then(r => r.data);
}

export const updateCultivationRoomName = async (id, name) => {
    return await axios.post(`${api}/cultivation/room/${id}/name`, {id, name}, axiosConfig).then(r => r.data);
}

export const insertPlantTable = async (name, roomId) => {
    return await axios.post(`${api}/cultivation/table`, {name, roomId}, axiosConfig).then(r => r.data);
}

export const getPlantTables = async (roomId) => {
    return await axios.get(`${api}/cultivation/table/room/${roomId}`, axiosConfig).then(r => r.data);
}

export const updatePlantTableName = async (id, name) => {
    return await axios.post(`${api}/cultivation/table/${id}/name`, {id, name}, axiosConfig).then(r => r.data);
}

export const deletePlantTable = async (tableId) => {
    return await axios.post(`${api}/cultivation/table/${tableId}/delete`, {tableId}, axiosConfig).then(r => r.data);
}

export const insertPlantRow = async (name, roomId, tableId) => {
    return await axios.post(`${api}/cultivation/row`, {name, roomId, tableId}, axiosConfig).then(r => r.data);
}

export const getPlantRows = async (roomId) => {
    return await axios.get(`${api}/cultivation/room/${roomId}/row`, axiosConfig).then(r => r.data);
}

export const updatePlantRowName = async (id, name) => {
    return await axios.post(`${api}/cultivation/row/${id}/name`, {id, name}, axiosConfig).then(r => r.data);
}

export const deletePlantRow = async (rowId) => {
    return await axios.post(`${api}/cultivation/row/${rowId}/delete`, {rowId}, axiosConfig).then(r => r.data);
}

export const resetMomPlant = async (plantId, count, notes, createdBy) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/reset`, {plantId, count, notes, createdBy}, axiosConfig).then(r => r.data);
}

export const getPlantProducts = async (strainId) => {
    return axios.get(`${api}/cultivation/strain/${strainId}/product`, axiosConfig).then(r => r.data);
}

export const insertPlantProduct = async (strainId, productId) => {
    return axios.post(`${api}/cultivation/strain/${strainId}/product`, {strainId, productId}, axiosConfig).then(r => r.data);
}

export const deletePlantProduct = async (strainId, productId) => {
    return axios.post(`${api}/cultivation/strain/${strainId}/product/delete`, {strainId, productId}, axiosConfig).then(r => r.data);
}

export const harvestPlant = async (plantId, notes, createdBy, date) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/harvest`, {plantId, notes, createdBy, date}, axiosConfig).then(r => r.data);
}

export const undoHarvestPlant = async (plantId, notes, createdBy, date) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/harvest`, {plantId, notes, createdBy, date, undo: 1}, axiosConfig).then(r => r.data);
}

export const upsertPlantTrim = async (plantId, productId, amount) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/trim`, {plantId, productId, amount}, axiosConfig).then(r => r.data);
}

export const getPlantTrim = async (plantId) => {
    return await axios.get(`${api}/cultivation/plant/${plantId}/trim`, axiosConfig).then(r => r.data);
}

export const deletePlantTrim = async (plantId, productId) => {
    return await axios.post(`${api}/cultivation/plant/${plantId}/trim/delete`, {plantId, productId}, axiosConfig).then(r => r.data);
}

export const updateBatchDescription = async (batchId, description) => {
    return await axios.post(`${api}/cultivation/batch/${batchId}/description`, {batchId, description}, axiosConfig).then(r => r.data);
}

export const finalizeHarvest = async (roomId, batchId, bulkCost) => {
    return await axios.post(`${api}/cultivation/room/${roomId}/harvest`, {roomId, batchId, bulkCost}, axiosConfig).then(r => r.data);
}

export const getHarvestedPlantsByBatch = async (batchId) => {
    return await axios.get(`${api}/cultivation/plant/batch/${batchId}`, axiosConfig).then(r => r.data);
}

export const getPlantTrimByBatch = async (batchId) => {
    return await axios.get(`${api}/cultivation/batch/${batchId}/trim`, axiosConfig).then(r => r.data);
}

export const insertTag = async (name) => {
    return await axios.post(`${api}/cultivation/tag`, {name}, axiosConfig).then(r => r.data);
}

export const getTags = async () => {
    return await axios.get(`${api}/cultivation/tag/all`, axiosConfig).then(r => r.data);
}

export const tagPlants = async (tagId, plantIds) => {
    return await axios.post(`${api}/cultivation/tag/${tagId}`, {tagId, plantIds}, axiosConfig).then(r => r.data);
}

export const removeTagPlant = async (tagId, plantId) => {
    return await axios.post(`${api}/cultivation/tag/${tagId}/delete`, {tagId, plantId}, axiosConfig).then(r => r.data);
}

export const getPlantTags = async (plantId) => {
    return await axios.get(`${api}/cultivation/plant/${plantId}/tags`, axiosConfig).then(r => r.data);
}

export const getTaggedPlants = async (tagId) => {
    return await axios.get(`${api}/cultivation/tag/${tagId}/plants`, axiosConfig).then(r => r.data);
}

export const getPlantStrains = async () => {
    return await axios.get(`${api}/cultivation/strains`, axiosConfig).then(r => r.data);
}

export const getPlantStrain = async (strainId) => {
    return await axios.get(`${api}/cultivation/strain/${strainId}`, axiosConfig).then(r => r.data[0]);
}

export const insertPlantStrain = async (name, description) => {
    return await axios.post(`${api}/cultivation/strain`, {name, description}, axiosConfig).then(r => r.data);
}

export const updateStrainName = async (id, name) => {
    return await axios.post(`${api}/cultivation/strain/${id}/name`, {id, name},  axiosConfig).then(r => r.data);
}

export const updateStrainDescription = async (id, description) => {
    return await axios.post(`${api}/cultivation/strain/${id}/description`, {id, description},  axiosConfig).then(r => r.data);
}

export const insertPlant = async (name, description, strain, metricTag, roomId, strainId, count, batchId) => {
    return await axios.post(`${api}/cultivation/plant`, {name, description, strain, metricTag, roomId, strainId, count, batchId}, axiosConfig)
        .then(r => r.data);
}

export const updatePlantStrain = async (id, strainId) => {
    return await axios.post(`${api}/cultivation/plant/${id}/strain`, {id, strainId}, axiosConfig).then(r => r.data);
}

export const getBatchNotes = async (batchId) => {
    return await axios.get(`${api}/cultivation/batch/${batchId}/notes`, axiosConfig).then(r => r.data);
}

export const insertBatchNote = async (batchId, notes) => {
    return await axios.post(`${api}/cultivation/batch/${batchId}/note`, {batchId, notes}, axiosConfig).then(r => r.data);
}

export const updateBatchNote = async (batchId, noteId, notes) => {
    return await axios.post(`${api}/cultivation/batch/${batchId}/note/${noteId}`, {noteId, notes, batchId}, axiosConfig).then(r => r.data);
}

export const updateBatch = async (batchId, values) => {
    return await axios.post(`${api}/cultivation/batch/${batchId}/info`, {id: batchId, ...values}, axiosConfig).then(r => r.data);
}

export const insertRoomBatch = async (roomId, batchId) => {
    return await axios.post(`${api}/cultivation/room/${roomId}/batch`, {roomId, batchId}, axiosConfig).then(r => r.data);
}

export const deleteRoomBatch = async (roomId) => {
    return await axios.post(`${api}/cultivation/room/${roomId}/batch/delete`, {roomId}, axiosConfig).then(r => r.data);
}

export const getRoomBatch = async (roomId) => {
    return await axios.get(`${api}/cultivation/room/${roomId}/batch`, axiosConfig).then(r => r.data[0]);
}

export const uploadImageFile = async (productId, file) => {
    console.log(file.type);
    const arrayBuffer = await file.arrayBuffer();
    return await axios.put(`${api}/product/${productId}/image`, arrayBuffer, {...axiosConfig, headers: {
            'Content-Type': file.type // e.g., 'image/png'
        }}).then(r => r.data);
}